import { MonitorStatus, monStatBadgeColors } from '@fe/core';
import clsx from 'clsx';

const monitorStatusNames: Record<MonitorStatus, string> = {
    [MonitorStatus.null]: '',
    [MonitorStatus.clear]: 'Clear',
    [MonitorStatus.info]: 'Info',
    [MonitorStatus.watch]: 'Watch',
    [MonitorStatus.warning]: 'Warning',
    [MonitorStatus.critical]: 'Critical',
    [MonitorStatus.emergency]: 'Emergency'
};

export function MonitorStatusBadge(props: { monitorStatus?: MonitorStatus | null; children?: React.ReactNode; onClick?: () => void }) {
    return (
        <div
            className={clsx(
                'monstat-badge',
                props.monitorStatus ? monStatBadgeColors[props.monitorStatus] : '',
                props.onClick && 'monstat-badge-clickable'
            )}
            onClick={props.onClick}>
            {props.children ?? monitorStatusNames[props.monitorStatus ?? MonitorStatus.null]}
        </div>
    );
}
